export default __webpack_public_path__ + "static/media/671.03fea52b.gif";